// extracted by mini-css-extract-plugin
module.exports = {"navigationItems":"NavigationItems_navigationItems__1CKhT","navButton":"NavigationItems_navButton__1nlrO","navButtonRes":"NavigationItems_navButtonRes__3QMMD"};